export const mediaBreakpoint = {
  medium: 1200,
  bigTablet: 992,
  tablet: 768,
  mobile: 480,
};
